import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Header from 'pages/App/Header';
import CreatePage from './Create';
import SuccessPage from './Success';

const ReservationPublicPage = () => {
  return (
    <div>
      <Header />
      <Routes>
        <Route path="/" element={<CreatePage />} />
        <Route path="/success" element={<SuccessPage />} />
      </Routes>
    </div>
  );
};

export default ReservationPublicPage;
